import { type IngestType } from '@/features/shop/services/Orders/types'

export const getOrderKey = (id: number, ingestType: IngestType) =>
  ['order', id, ingestType] as const
